import { render, staticRenderFns } from "./IzvestajGost.vue?vue&type=template&id=408264ed&scoped=true"
import script from "./IzvestajGost.vue?vue&type=script&lang=js"
export * from "./IzvestajGost.vue?vue&type=script&lang=js"
import style1 from "./IzvestajGost.vue?vue&type=style&index=1&id=408264ed&prod&scoped=true&lang=css"
import style2 from "./IzvestajGost.vue?vue&type=style&index=2&id=408264ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408264ed",
  null
  
)

export default component.exports